/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES 料金システム用 API
 * PR TIMES 料金システムで使うAPI。
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    BookingPlan,
    BookingPlanFromJSON,
    BookingPlanFromJSONTyped,
    BookingPlanToJSON,
} from './BookingPlan';

/**
 * 
 * @export
 * @interface GetBookingPlanResponse
 */
export interface GetBookingPlanResponse {
    /**
     * status code (HTTPと同じ)
     * @type {number}
     * @memberof GetBookingPlanResponse
     */
    status: number;
    /**
     * ステータスメッセージ。原則英語。
     * @type {string}
     * @memberof GetBookingPlanResponse
     */
    message: string;
    /**
     * 
     * @type {BookingPlan}
     * @memberof GetBookingPlanResponse
     */
    data: BookingPlan | null;
}

export function GetBookingPlanResponseFromJSON(json: any): GetBookingPlanResponse {
    return GetBookingPlanResponseFromJSONTyped(json, false);
}

export function GetBookingPlanResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetBookingPlanResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'status': json['status'],
        'message': json['message'],
        'data': BookingPlanFromJSON(json['data']),
    };
}

export function GetBookingPlanResponseToJSON(value?: GetBookingPlanResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'status': value.status,
        'message': value.message,
        'data': BookingPlanToJSON(value.data),
    };
}

